import { useContext } from 'react';
import UserContext from './global_context';

const usePermissionValue = () => {

  const context = useContext(UserContext),
        { state: { NavFunctions: { navFunctionData = { navFunctionData: false } } = { NavFunctions: false } } = { state: false } } = context || {};

  const getPermValue = (key) => {
    const record = navFunctionData.find((el) => el.navMode?.trim()?.toUpperCase() === key?.trim()?.toUpperCase());
    const { CanAdd = false, CanUpdate = false, CanDelete = false } = record || {};
    const perm = { ...{
      CanAdd,
      CanUpdate,
      CanDelete,
    },
    };
    return perm;
  };

  return {
    getPermValue,
  };

};

export default usePermissionValue;